document.addEventListener('DOMContentLoaded', function () {
    const infoPopup = document.querySelector('.info-popup-contact');
    const popupMain = document.querySelector('.custom-model-main');
    const closeBtn = document.querySelector('.close-btn');
    const bgOverlay = document.querySelector('.bg-overlay');

    function showPopup() {
        popupMain.style.display = 'block';
    }

    function hidePopup() {
        popupMain.style.display = 'none';
    }

    infoPopup.addEventListener('click', function (e) {
        e.preventDefault();
        showPopup();
    });

    closeBtn.addEventListener('click', function () {
        hidePopup();
    });

    bgOverlay.addEventListener('click', function () {
        hidePopup();
    });
});
